{
  "version": 1,
  "asset_id": "6d61ca1d-8ca8-4169-b27e-345491efb30f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/6d61ca1d-8ca8-4169-b27e-345491efb30f/svc-cro-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/6d61ca1d-8ca8-4169-b27e-345491efb30f/svc-cro-1200.avif",
  "original_filename": "svc-cro-1200.avif",
  "size": 9965,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:46Z"
}
